<div class="pdf-page-container">

  <!-- Page content -->
  <div class="pdf-page-content with-sidebar">

    <div class="visible-xs-block text-center mobile-sidebar-toggle">
      <a [attr.href] = "null" (click)="showSidebar()"><i class="{{toogleSidebar ? 'icon-minus3' : 'icon-plus3'}}"></i> {{'Sidebar Menu' | translate}}</a>
    </div>

    <!-- Main sidebar -->
    <div class="sidebar sidebar-main sidebar-default sidebar-separate">
      <div class="sidebar-content">

        <!-- Keep Validation Stamp section -->
        <h4 style="background-color: #DDDDDD; padding: 8px 0; text-align: center">
          {{'Validation Stamp' | translate}}
          <span class="badge badge-secondary">
            <input #validationStamp type="checkbox" style="display: block;"
                   name="validation-stamp" id="validation-stamp"
                   class="js-switch js-check-change" checked/>
          </span>
        </h4>

        <!-- External toolbar container for pdf-form-designer -->
        <div id="external-toolbar" class="toolbar-container" style="margin-top: 20px;">
          <!-- Toolbar will be moved here by pdf-form-designer -->
        </div>

        <!-- ========================================
             BETA FEATURE
             ======================================== -->
        <!-- Beta: Download preview with applied design -->
        <div style="margin: 10px 10px; text-align: center;">
          <button class="btn btn-link btn-sm" (click)="downloadDesignPreview()" style="color: #999; font-size: 12px;">
            <i class="icon-download" style="font-size: 11px;"></i> {{'Download Preview' | translate}} <span style="font-weight: normal;">(BETA)</span>
          </button>
        </div>
        <!-- ========================================
             END BETA FEATURE
             ========================================== -->

      </div>
    </div>
    <!-- /main sidebar -->

    <!-- Main content with PDF Form Designer -->
    <div class="pdf-content-area text-center">
      <div class="content" *ngIf="pdfSrc.url">

        <lib-pdf-form-designer
          #pdfDesigner

          [pdfSrc]="pdfSrc"
          [options]="designerOptions"
          [initialConfiguration]="initialConfiguration"
          [externalToolbar]="externalToolbar"
          [toolbarContainerId]="'external-toolbar'"
          (configurationChange)="onConfigurationChange($event)"
          (zoomChange)="onZoomChange($event)">
        </lib-pdf-form-designer>


      </div>
      <!-- /content area -->
    </div>
    <!-- /main content -->

  </div>
  <!-- /page content -->

</div>

<!-- Validation Stamp Settings Modal -->
<div id="validationStampSettings" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md center-modal" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="text-semibold modal-title" translate>Validation Stamp Settings</h5>
      </div>
      <form #form="ngForm" class="form-horizontal">
        <div class="modal-body">
          <div class="form-group">
            <label class="control-label col-sm-6 col-xs-4 text-left" for="vsEnabled"><strong translate>Enabled</strong></label>
            <span class="badge badge-secondary">
                <label class="switch">
                <input type="checkbox" class="js-check-change" id="vsEnabled" [(ngModel)]="validationStampSettings.enabled" name="vsEnabled" #vsEnabled="ngModel" [checked]="validationStampSettings.enabled"/>
                <span class="slider round"> </span>
                </label>
              </span>
          </div>

          <div class="form-group">
            <label class="control-label col-sm-6 col-xs-4 text-left" for="downloadFromValidation"><strong translate>Download From Validation</strong></label>
            <span class="badge badge-secondary">
              <label class="switch">
                <input type="checkbox" (click)="toggleDownload()" [checked]="validationStampSettings.downloadFromValidation">
                <span class="slider round"> </span>
              </label>
              </span>
          </div>

          <div class="form-group">
            <label class="control-label col-sm-6 col-xs-4 text-left" for="legalDisclaimer"><strong translate>Legal Disclaimer</strong></label>
            <span class="badge badge-secondary">
              <label class="switch">
                <input type="checkbox" (click)="toggleLegalDisclaimer()" [checked]="validationStampSettings.legalDisclaimer">
                <span class="slider round"> </span>
              </label>
              </span>
          </div>

          <div class="form-group">
            <label class="control-label col-sm-4 col-xs-4 text-left" for="vsFirstPageBottomMargin"><strong translate>First Page Bottom Margin</strong></label>
            <div class="col-sm-2 col-xs-4">
              <input type="number" class="form-control" id="vsFirstPageBottomMargin" [ngClass]="{'error':!vsFirstPageBottomMargin.valid}" [(ngModel)]="validationStampSettings.firstPageBottomMargin" name="vsFirstPageBottomMargin" #vsFirstPageBottomMargin="ngModel" required min="0">
            </div>
          </div>

          <div class="form-group">
            <label class="control-label col-sm-4 col-xs-4 text-left" for="vsQrCodeXMargin"><strong translate>QR-Code X Margin</strong></label>
            <div class="col-sm-2 col-xs-4">
              <input type="number" class="form-control" id="vsQrCodeXMargin" [ngClass]="{'error':!vsQrCodeXMargin.valid}" [(ngModel)]="validationStampSettings.qrCodeXMargin" name="vsQrCodeXMargin" #vsQrCodeXMargin="ngModel" required min="0">
            </div>
          </div>

          <div class="form-group">
            <label class="control-label col-sm-4 col-xs-4 text-left" for="vsQrCodeYMargin"><strong translate>QR-Code Y Margin</strong></label>
            <div class="col-sm-2 col-xs-4">
              <input type="number" class="form-control" id="vsQrCodeYMargin" [ngClass]="{'error':!vsQrCodeYMargin.valid}" [(ngModel)]="validationStampSettings.qrCodeYMargin" name="vsQrCodeYMargin" #vsQrCodeYMargin="ngModel" required min="0">
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" translate>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveValidationStampSettings()" data-dismiss="modal" translate>Done</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Request Modal -->
<div *ngIf="requestModalVisibility">
  <sd-request
    [job]="theJob"
    (modalClosed)="requestModalClosed()"
    (recipientAdded)="onRecipientAdded($event)"
    (recipientRemoved)="onRecipientRemoved($event)"
    (recipientUpdated)="onRecipientUpdated($event)"
    (jobUpdated)="onJobUpdated($event)">
  </sd-request>
</div>

<!-- Shared Signing Modal -->
<div *ngIf="sharedSigningModalVisibility">
  <sd-shared-signing [theJob]="theJob" (modalClosed)="sharedSigningClosed()"></sd-shared-signing>
</div>

<!-- Attachments Modal -->
<div *ngIf="attachmentsModalVisibility">
  <app-attachments-modal
    [documentId]="theJob?.documents[0]?.id"
    [editable]="true"
    [jobName]="theJob?.name"
    (modalClosed)="onAttachmentsClosed()"
    (attachmentsChanged)="onAttachmentsChanged($event)">
  </app-attachments-modal>
</div>
